import { render, staticRenderFns } from "./mobile-recording.vue?vue&type=template&id=6bd4d3a8&scoped=true"
import script from "./mobile-recording.vue?vue&type=script&lang=js"
export * from "./mobile-recording.vue?vue&type=script&lang=js"
import style0 from "./mobile-recording.vue?vue&type=style&index=0&id=6bd4d3a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd4d3a8",
  null
  
)

export default component.exports